import { CorporateFormValues, CorporateRequest } from './Corporate.model';

const parseFormValuesForRequest = (formValues: CorporateFormValues): CorporateRequest => ({
  ...formValues,
  totalEmployees: Number(formValues.totalEmployees) || null,
});

export default parseFormValuesForRequest;
